<!-- splash screen -->
<div #splashScreen id="splash-screen">
  <img src="assets/media/logo/Block_logo_web_black.png" alt="Logo" class="w-120px" />
  <svg class="splash-spinner" viewBox="0 0 50 50">
    <circle class="path" cx="25" cy="25" r="20" fill="none" stroke-width="10"></circle>
  </svg>
  <span style="font-weight:600">Working on your request please wait, do not navigate away...</span>
</div>
